import dotProp from 'dot-prop';
const isObject = (value: any) => value && typeof value === 'object' && value.constructor === Object;

const exportFunc = (object: any): string[] => {
  const obj = { ...object };
  const paths: string[] = [];
  const getPath = (object: any, glue = '.'): string => {
    if (!isObject(object) && !Array.isArray(object)) {
      return '';
    }
    const currentKey = Object.keys(object)[0];
    if (!getPath(object[currentKey])) {
      return currentKey;
    }
    return currentKey + glue + getPath(object[currentKey]);
  };
  while (Object.keys(obj).length > 0) {
    const path = getPath(obj);
    const item = dotProp.get(obj, path);
    if (!Array.isArray(item) && !(isObject(item) && !Object.keys(item as object).length)) {
      paths.push(path);
    }
    dotProp.delete(obj, path);
  }
  return paths;
};

export default exportFunc;
